import { SIMPLE_PAYMENTS_SERVICE_GW_PREFIX } from "../constants";
import { CreateCustomerRequest, CreateCustomerResponse } from "./models";
import { createApiClientWithArgs } from "cy-fetch/lib/client";

export * from "./models";

export const createCustomerUrl = `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers`;

export const createCustomerClient = createApiClientWithArgs({
  zod: CreateCustomerResponse,
  argsFn: (args: CreateCustomerRequest) => {
    return {
      url: createCustomerUrl,
      options: {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ customer: args }),
      },
    };
  },
});
